import React from "react";
import img1 from '../../assets/Clip Arts/I11.png'
import img2 from '../../assets/Clip Arts/I33.png'
import img3 from '../../assets/Clip Arts/I22.png'
import img4 from '../../assets/Clip Arts/I44.png'
import img5 from '../../assets/Clip Arts/I66.png'
import img6 from '../../assets/Clip Arts/I55.png'
import img7 from '../../assets/Clip Arts/I77.png'
import img8 from '../../assets/Clip Arts/I88.png'
const Skills = () => {
  return (
    <>
      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img1}
            alt="Video Production"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Video Production
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img2}
            alt="Content Creation"
            style={{
              width: "200px",
              height: "200px",
              objectFit: "cover",
              color:"black"
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Content Creation
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img3}
            alt="Digital Marketing"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Digital Marketing
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img4}
            alt="Social Media Management"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Social Media Management
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img5}
            alt="Film Production"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Film Production
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img6}
            alt="Documentary"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Documentary
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img7}
            alt="Corporate Video"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          Corporate Video
        </h6>
      </div>

      <div className="col-6 col-md-3  ">
        <div style={{ textAlign: "center" }}>
          <img
            src={img8}
            alt="IT Services"
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>
        <h6 className="text-uppercase open-sans-font text-center ">
          IT Services
        </h6>
      </div>
    </>
  );
};

export default Skills;
